// Khpur.jsx  ✅ (only translation changes + keep logic same)
import React, { useEffect, useRef, useState, useContext } from 'react'
import back from "../../imgs/backexam.png";
import './Khpur.css'
import { ToastContainer, toast } from 'react-toastify';
import cash from "../../imgs/cash.png";
import axios from 'axios';
import { UilEditAlt, UilTrash, UilSetting } from '@iconscout/react-unicons'
import { useLocation, useNavigate } from "react-router-dom";
import Globalcontext from '../../Context/Globalcontext';
import Khpurjma from '../Khpurjma/Khpurjma';

import { useTranslation } from "react-i18next";

const Khpur = (props) => {

    const inputRefs = useRef([]);
    const [newedit, setNewedit] = useState("new");
    const [input, setInput] = useState({ date: new Date().toISOString().substr(0, 10), khname: "", khcompany: "", quin: "", rate: "", srate: "", amt: "", kno: "", name: "" });
    const [DataSource, setDataSource] = useState([]);
    const [tableFilter, setTableFilter] = useState([]);
    const [khnames, setKhnames] = useState([]);
    const [company, setCompany] = useState([]);
    const [value, setValue] = useState('');
    const { submenu, setsubmenu, newcustsource, setNewcustsource, custlist, setCustlist } = useContext(Globalcontext);
    const [stock, setStock] = useState();
    const { sanksource, setSanksource, setHeadname } = useContext(Globalcontext);
    const [stockcompany, setStockcompany] = useState();
    const notify = (msg) => toast(msg);
    const notifyerror = (msg) => toast.error(msg);
    const [sredit, setSredit] = useState('');
    const [partyData, setPartydata] = useState([]);
    const [mastermenu, setMastermenu] = useState(true);
    const [kopen, setkopen] = useState(0);
    const today = new Date().toISOString().split('T')[0];
    const [transitionEnded, setTransitionEnded] = useState(true);

    const [t] = useTranslation();

    function handleEnterKey(event, currentIndex) {
        if (event.key === 'Enter' || event.key === "Tab") {
            event.preventDefault();
            let nextIndex = null;
            nextIndex = currentIndex + 1;
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }

        // ✅ Keep this logic as-is (only existing Marathi strings were here)
        if (event.key === 'Backspace' && (
            (event.target.tagName === 'INPUT' && event.target.value === '') ||
            (event.target.tagName === 'SELECT' && (
                (event.target.name === 'type' && event.target.value === 'प्रकार निवडा') ||
                (event.target.name === 'time' && event.target.value === 'वेळ निवडा')
            ))
        )) {
            event.preventDefault();

            let prevIndex = currentIndex - 1;
            while (prevIndex >= 0) {
                const prevElement = inputRefs.current[prevIndex];
                if (prevElement) {
                    if (
                        (prevElement.tagName === 'INPUT' || prevElement.tagName === 'SELECT') &&
                        prevElement !== event.target
                    ) {
                        prevElement.focus();
                        break;
                    } else {
                        prevIndex--;
                    }
                } else {
                    prevIndex--;
                }
            }
        }
    }

    useEffect(() => {
        if (input.kno === "") {
            if (newedit === 'new') {
                setInput(prevInput => ({
                    ...prevInput,
                    khname: "",
                    quin: "",
                    rate: "",
                    amt: "",
                    kno: "",
                    name: ""
                }))
                setSredit("");
                setNewedit("new");
            }
            else {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ""
                }))
            }
        }
        else {
            let custlisttemp = partyData;
            for (let i = 0; i < custlisttemp.length; i++) {
                setInput(prevInput => ({
                    ...prevInput,
                    name: ''
                }));
                const user = custlisttemp[i];
                if (user.kno === input.kno) {
                    setInput(prevInput => ({
                        ...prevInput,
                        name: user.name,
                    }));
                    break;
                }
            }
        }
    }, [input.kno])

    async function getkhpartylist(flag) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhpartylist.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data.length > 0) {
                setPartydata(response.data);
                localStorage.setItem("dlist", JSON.stringify(response.data));
            }
        }).catch(err => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (input.rate && input.rate !== "" && input.quin && input.quin !== "") {
            let amt = parseFloat(parseFloat(input.rate) * parseFloat(input.quin)).toFixed(2);
            setInput(prevInput => ({
                ...prevInput,
                amt: amt,
            }))
        }
    }, [input.rate, input.quin])


    const getstockcompany = async () => {
        if (input.khcompany) {
            company.map((user, index) =>
                user.khcompany === input.khcompany && user.khcompany !== "-" ?
                    setStockcompany(user.current_stock)
                    : ""
            )
        }
        getkhcompany();
    }

    async function getkhcompany() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        setTimeout(() => {
            props.setProgress(70);
        }, 200);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhcompany.php', { khname: input.khname, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data) {
                setCompany(response.data);
            }

        }).catch(err => {
            console.log(err);
        });
    }

    const savekhadyapur = () => {
        var mainuser2 = jsEncode.encode("mamapr", 125);

        // ✅ translated UI errors
        if (input.date === "" || input.khname === "" || input.quin === "" || input.rate === "" || input.srate === "" || input.amt === "" || input.kno === "" || input.name === "") {
            notifyerror(t("khpur.toast.incomplete"));
            if (inputRefs.current[0]) {
                inputRefs.current[0].focus();
            }
            return;
        }

        let rawData = {
            date: input.date,
            kno: input.kno,
            khname: input.khname,
            khcompany: input.khcompany,
            quin: input.quin,
            rate: input.rate,
            srate: input.srate,
            amt: input.amt,
            mainuser: localStorage.getItem("contact"),
            mainuser2: mainuser2,
            flag: newedit,
            sredit: sredit,
        }
        rawData = JSON.stringify(rawData)
        let formData = new FormData()
        if (newedit === "edit") {
            formData.append('data', rawData)
        }
        else if (newedit === "new") {
            formData.append('data', rawData)
        }
        axios.post('https://excellentdairy.com/dairy/php/cust/savekhpur2.php', formData, {
            'Content-Type': 'multipart/form-data',
        }).then(function sample(response) {

            if (newedit === "new") {
                if (response.data.trim() === "Saved.") { // keep excellentdairy string
                    notify(t("khpur.toast.saved"));
                }
            }
            else {
                if (response.data.trim() === "updated.") { // keep excellentdairy string
                    notify(t("khpur.toast.updated"));
                }
            }
            setInput(prevInput => ({
                ...prevInput,
                kno: "",
                name: "",
                khname: "",
                khcompany: "",
                quin: "",
                rate: "",
                srate: "",
                amt: "",
            }))
            setStock(null)
            setSredit("");
            setNewedit("new");
            getkhpur();
            if (inputRefs.current[0]) {
                inputRefs.current[0].focus();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const handleedit = (sr, date, kno, name, khname, khcompany, quin, rate, amt, srate) => {
        setInput(prevInput => ({
            ...prevInput,
            name: ""
        }))
        setInput({ sr: sr, date: date, kno: kno, khname: khname, khcompany: khcompany, quin: quin, rate: rate, amt: amt, srate: srate })
        setNewedit("edit");
        setSredit(sr);
    }

    async function deletesanklan(sr) {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/deletekhpur.php', { sr: sr, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                notify(response.data); // keep excellentdairy response
                setInput(prevInput => ({
                    ...prevInput,
                    khname: "",
                    quin: "",
                    rate: "",
                    amt: "",
                }))
                setSredit("");
                setNewedit("new");
                getkhpur();
                if (inputRefs.current[0]) {
                    inputRefs.current[0].focus();
                }
            }
        }).catch(err => {
            console.log(err);
        });
    }

    async function getkhname() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhname.php', { mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {
            if (response.data) {
                setKhnames(response.data);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    function handleEnterKeybutton(event, currentIndex) {
        if (event.key === 'Enter') {
            event.preventDefault();
            savekhadyapur();
            let nextIndex = null;
            if (currentIndex === 0) {
                if (input.name !== "") {
                    nextIndex = currentIndex + 1;
                }
                else {
                    nextIndex = currentIndex;
                }
            }
            else {
                nextIndex = currentIndex + 1;
            }
            if (inputRefs.current[nextIndex]) {
                inputRefs.current[nextIndex].focus();
            }
        }
        else if (event.key === "Backspace") {
            if (event.target.tagName === "BUTTON") {
                if (inputRefs.current[2]) {
                    inputRefs.current[2].focus();
                }
            }
        }
    }

    useEffect(() => {
        getkhpur();
        if (inputRefs.current[0]) {
            inputRefs.current[0].focus();
        }
    }, [])

    async function getkhpur() {
        var mainuser2 = jsEncode.encode("mamapr", 125);
        axios.post('https://excellentdairy.com/dairy/php/cust/getkhpur.php', { date: input.date, time: input.time, mainuser: localStorage.getItem("contact"), mainuser2: mainuser2 }).then(function sample(response) {

            if (response.data) {
                setDataSource(response.data);
                setTimeout(() => {
                    props.setProgress(100);
                }, 200);
            }
            getkhpartylist();
        }).catch(err => {
            console.log(err);
        });
        getkhname();
    }

    const getstock = async () => {
        if (input.khname) {
            khnames.map((user, index) =>
                user.khname === input.khname ?
                    setStock(user.current_stock)
                    : ""
            )
        }
        else {
            setStock("");
            setStockcompany("");
        }
        getkhcompany();
    }

    useEffect(() => {
        setStock("");
        setStockcompany("");
        setCompany([]);
        getkhcompany();
    }, [input.khname])

    const handleChange = async (event) => {
        const name = event.target.name;
        let valuecurrent = "";
        valuecurrent = event.target.value;
        setInput(value => ({ ...value, [name]: valuecurrent }));

        if (name === 'date') {
            if (value === "" || value === "dd/mm/yyyy" || value > today) {
                setInput(prevInput => ({
                    ...prevInput,
                    date: prevInput.date && prevInput.date <= today ? prevInput.date : today
                }));
                return;
            }
        }
    }

    useEffect(() => {
        if (input.khname) {
            khnames.map((user, index) =>
                user.khname === input.khname ?
                    setStock(user.current_stock)
                    : setStock(null)
            )
        }
    }, [input.khname])

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        }).replace(/ /g, '-');
    };

    useEffect(() => {
        if (input.khcompany) {
            khnames.map((user, index) =>
                user.khname === input.khname && user.khcompany === input.khcompany ?
                    setStockcompany(user.current_stock)
                    : setStockcompany(null)
            )
        }
    }, [input.khcompany])

    var jsEncode = {
        encode: function (s, k) {
            var enc = "";
            var str = s.toString();
            for (var i = 0; i < str.length; i++) {
                var a = str.charCodeAt(i);
                var b = a ^ k;
                enc = enc + String.fromCharCode(b);
            }
            return enc;
        }
    };

    const visibility = () => {
        localStorage.setItem("glcustsr", "");
        setTransitionEnded(false);
        setMastermenu(!mastermenu);
        setkopen(0);
        setsubmenu("");
        setHeadname(t("head.daily"));
    }

    const opendjma = (flag) => {
        setsubmenu("khpurjma");
        setHeadname(t("khpur.head.due_credit"));
    };

    return (
        <div className="khadyamain">
            <div className="firstrowkhadya">
                <img onClick={props.visibility} className='back' src={back} alt="" />
                <div className="colmainkhadya">
                    <div className="firstrow2">
                        <div className="rowsank">
                            <div className="mb-2">
                                <span className='subheadsank'>{t("common.date")}</span>
                                <input
                                    max={today}
                                    onKeyDown={e => handleEnterKey(e, 0)}
                                    ref={ref => (inputRefs.current[0] = ref)}
                                    type="date"
                                    className={newedit === "new" ? "form-control inputfont" : "form-control inputfont editmode"}
                                    autoComplete='off'
                                    id="date"
                                    name="date"
                                    value={input.date}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div onClick={opendjma} className="rightkhpur">
                        <img className='backratib' src={cash} alt="" />
                        <span className='subheadsankratib'>{t("khpur.head.due_credit")}</span>
                    </div>
                </div>
            </div>

            <div className='linesank' />

            <div className="row1khpur">
                <div className="mb-2">
                    <span className='subheadsank'>{t("khpur.labels.dealer_no")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 1)}
                        ref={ref => (inputRefs.current[1] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control inputfontkh" : "form-control inputfontkh editmode"}
                        autoComplete='off'
                        id="kno"
                        name="kno"
                        value={input.kno}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2 hhhh">
                    <span className='subheadsank'>{t("khpur.labels.dealer_name")}</span>
                    <input
                        type="text"
                        disabled
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="name"
                        name="name"
                        value={input.name}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="row1khpur">
                <div className="mb-2">
                    <span className='subheadsank'>{t("khpur.labels.feed_name")}</span>
                    <input
                        list='khnamelist'
                        onKeyDown={e => handleEnterKey(e, 2)}
                        ref={ref => (inputRefs.current[2] = ref)}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="khname"
                        name="khname"
                        value={input.khname}
                        onChange={handleChange}
                        onBlur={getstock}
                    />
                    <datalist id="khnamelist">
                        {khnames && [...new Set(khnames.map(opt => opt.khname))].map((uniqueCompany, index) => (
                            <option key={index} value={uniqueCompany}>{uniqueCompany}</option>
                        ))}
                    </datalist>
                </div>

                <div className="mb-2">
                    <span className='subheadsank'>
                        {t("khpur.labels.feed_company")}
                        {stockcompany && (
                            <span className='lblredkh'> {t("khpur.text.balance_stock", { stock: stockcompany })}</span>
                        )}
                    </span>

                    <input
                        list='khcompanylist'
                        onKeyDown={e => handleEnterKey(e, 3)}
                        ref={ref => (inputRefs.current[3] = ref)}
                        className={newedit === "new" ? "form-control inputfontkhlarge" : "form-control inputfontkhlarge editmode"}
                        autoComplete='off'
                        id="khcompany"
                        name="khcompany"
                        value={input.khcompany}
                        onChange={handleChange}
                        onBlur={getstockcompany}
                    />
                    <datalist id="khcompanylist">
                        {company && [...new Set(company.map(opt => opt.khcompany))].map((uniqueCompany, index) => (
                            <option key={index} value={uniqueCompany}>{uniqueCompany}</option>
                        ))}
                    </datalist>
                </div>

                <div className="mb-2 kkh">
                    <span className='subheadsank'>{t("khpur.labels.qty")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 4)}
                        ref={ref => (inputRefs.current[4] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                        autoComplete='off'
                        id="quin"
                        name="quin"
                        value={input.quin}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2 kkh">
                    <span className='subheadsank'>{t("khpur.labels.purchase_rate")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 5)}
                        ref={ref => (inputRefs.current[5] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                        autoComplete='off'
                        id="rate"
                        name="rate"
                        value={input.rate}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2 kkh">
                    <span className='subheadsank'>{t("khpur.labels.sale_rate")}</span>
                    <input
                        onKeyDown={e => handleEnterKey(e, 6)}
                        ref={ref => (inputRefs.current[6] = ref)}
                        type="number"
                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                        autoComplete='off'
                        id="srate"
                        name="srate"
                        value={input.srate}
                        onChange={handleChange}
                    />
                </div>

                <div className="mb-2 kkh2 hhhh">
                    <span className='subheadsank'>{t("khpur.labels.total")}</span>
                    <input
                        disabled
                        type="number"
                        className={newedit === "new" ? "form-control" : "form-control editmode"}
                        autoComplete='off'
                        id="amt"
                        name="amt"
                        value={input.amt}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="mb-2">
                <button
                    onClick={savekhadyapur}
                    onKeyDown={e => handleEnterKeybutton(e, 0)}
                    ref={ref => (inputRefs.current[7] = ref)}
                    type="submit"
                    className="btn btn-primary mx-1 sanksmall"
                >
                    {newedit === "new" ? t("common.save") : t("common.update")}
                </button>

        
            </div>

            <div className="firstrow2">
                <div className="table-containerkh">
                    <table id="myTablepur" className="table table-bordered">
                        <thead>
                            <tr>
                                <th className='thsmall' scope="col">{t("khpur.table.sr")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.date")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.dealer")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.feed")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.company")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.qty")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.purchase_rate")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.sale_rate")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.total")}</th>
                                <th className='thsmall' scope="col">{t("khpur.table.action")}</th>
                            </tr>
                        </thead>

                        <tbody>
                            {value.length > 0
                                ? tableFilter.map((user, index) =>
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{user.date}</td>
                                        <td>{user.name}</td>
                                        <td>{user.khname}</td>
                                        <td>{user.khcompany}</td>
                                        <td>{user.quin}</td>
                                        <td>{user.rate}</td>
                                        <td>{user.srate}</td>
                                        <td>{user.amt}</td>
                                        <td>
                                            <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.kno, user.name, user.khname, user.khcompany, user.quin, user.rate, user.amt, user.srate) }} className="icsank" />
                                            <UilTrash onClick={() => { deletesanklan(user.sr) }} className="icsank" />
                                        </td>
                                    </tr>
                                )
                                : DataSource.map((user, index) =>
                                    <tr key={index}>
                                        <td className='thsmallaudit'>{index + 1}</td>
                                        <td className='thsmallaudit'>{formatDate(user.date)}</td>
                                        <td className='thsmallaudit'>{user.name}</td>
                                        <td className='thsmallaudit'>{user.khname}</td>
                                        <td className='thsmallaudit'>{user.khcompany}</td>
                                        <td className='thsmallaudit'>{user.quin}</td>
                                        <td className='thsmallaudit'>{user.rate}</td>
                                        <td className='thsmallaudit'>{user.srate}</td>
                                        <td className='thsmallaudit'>{user.amt}</td>
                                        <td>
                                            <UilEditAlt onClick={() => { handleedit(user.sr, user.date, user.kno, user.name, user.khname, user.khcompany, user.quin, user.rate, user.amt, user.srate) }} className="icsank" />
                                            <UilTrash onClick={() => { deletesanklan(user.sr) }} className="icsank" />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default Khpur
